/**
 * Variant Color Gallery Filter v2
 *
 * Fixes:
 *  - Filters BOTH main slider AND thumbnail slider (not just thumbs)
 *  - Destroys & remounts Splide so slide counts are correct
 *  - PhotoSwipe lightbox only shows images for the selected color
 *    (removed slides are outside the gallery DOM, so PhotoSwipe won't find them)
 *
 * Color codes in filenames: AW=White, AB=Blue, AA=Ash, AC=Charcoal, AE=Ebony, AT=Timber
 * Pattern: "VDB1221-AW-Hero_xxx" or "AW-Door-Closeup_xxx"
 */
(function () {
  'use strict';

  function init() {

    /* ── 1. Parse product JSON ─────────────────────────────────── */
    var productJsonEl = document.querySelector('[id^="ProductCardJson-"]');
    if (!productJsonEl) { console.log('[VIF] No ProductCardJson element found'); return; }

    var product;
    try { product = JSON.parse(productJsonEl.textContent); }
    catch (e) { console.log('[VIF] Failed to parse product JSON', e); return; }

    console.log('[VIF] Product:', product.title, '| Options:', product.options);

    /* ── 2. Find Color option ──────────────────────────────────── */
    var colorOptionIndex = product.options.findIndex(function (o) {
      return ['color', 'colour', 'Color', 'Colour'].indexOf(o) !== -1;
    });
    if (colorOptionIndex === -1) { console.log('[VIF] No Color option found in:', product.options); return; }
    var colorKey = 'option' + (colorOptionIndex + 1);
    console.log('[VIF] Color option found at index', colorOptionIndex, '| key:', colorKey);

    /* ── 3. Build colorValue → 2-letter code map ───────────────── */
    var colorCodeMap = {};
    product.variants.forEach(function (v) {
      var color = v[colorKey];
      if (!color || colorCodeMap[color]) return;
      var src = (v.featured_image && v.featured_image.src)
             || (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src);
      if (!src) { console.log('[VIF] Variant', color, 'has no featured_image/media'); return; }
      var filename = src.split('/').pop().split('?')[0];
      var m = filename.match(/[_-]([A-Z]{2,3})[_-]/);
      if (m) colorCodeMap[color] = m[1];
      else console.log('[VIF] No color code match in filename:', filename);
    });
    console.log('[VIF] Color code map:', JSON.stringify(colorCodeMap));
    var allCodes = Object.values(colorCodeMap);
    if (allCodes.length === 0) { console.log('[VIF] Empty color map — aborting'); return; }

    /* ── 4. DOM references ─────────────────────────────────────── */
    var splideHost = document.querySelector('splide-slider[data-is-navigation="true"]');
    if (!splideHost) { console.log('[VIF] No splide-slider host found'); return; }

    var mainEl   = splideHost.querySelector('.main-thumb-slider');
    var thumbEl  = splideHost.querySelector('.switcher-thumb-slider');
    if (!mainEl || !thumbEl) { console.log('[VIF] Missing main or thumb slider element'); return; }

    var mainList  = mainEl.querySelector('.splide__list');
    var thumbList = thumbEl.querySelector('.splide__list');
    if (!mainList || !thumbList) return;

    /* Hidden container to park filtered-out slides */
    var storage = document.createElement('div');
    storage.style.display = 'none';
    storage.className = 'vif-storage';
    document.body.appendChild(storage);

    /* ── 5. Capture original slide order (once, after Splide mounts) */
    var origMain  = [];
    var origThumb = [];
    var captured  = false;

    function captureSlides() {
      if (captured) return;
      var ms = mainList.querySelectorAll(':scope > .splide__slide');
      var ts = thumbList.querySelectorAll(':scope > .splide__slide');
      for (var i = 0; i < ms.length; i++) {
        origMain.push({ el: ms[i], mediaId: ms[i].dataset.mediaId });
      }
      for (var j = 0; j < ts.length; j++) {
        origThumb.push({ el: ts[j], mediaId: ts[j].dataset.target });
      }
      captured = true;
    }

    /* ── 6. Decide if a media belongs to the selected color ────── */
    function shouldShow(mediaId, myCode) {
      var td = null;
      for (var i = 0; i < origThumb.length; i++) {
        if (origThumb[i].mediaId === mediaId) { td = origThumb[i]; break; }
      }
      if (!td) return true;

      var img = td.el.querySelector('img');
      var src = (img && (img.src || img.dataset.src || img.currentSrc)) || '';
      var file = src.split('/').pop().split('?')[0].toUpperCase();
      if (!file) return true;

      var codeRe = new RegExp('(^|[_-])' + myCode + '([_-])');
      var hasMyCode = codeRe.test(file);

      var hasOtherCode = false;
      for (var c = 0; c < allCodes.length; c++) {
        if (allCodes[c] === myCode) continue;
        if (new RegExp('(^|[_-])' + allCodes[c] + '([_-])').test(file)) {
          hasOtherCode = true;
          break;
        }
      }

      /* Show if: matches my code, OR is generic (no color code at all) */
      return hasMyCode || !hasOtherCode;
    }

    /* ── 7. Splide destroy / remount helpers ───────────────────── */
    function destroySplides() {
      try { if (mainEl.splide)  mainEl.splide.destroy();  } catch (e) { /* ok */ }
      try { if (thumbEl.splide) thumbEl.splide.destroy(); } catch (e) { /* ok */ }
      mainEl.splide  = null;
      thumbEl.splide = null;
    }

    function mountSplides() {
      var ds = splideHost.dataset;

      var mainOpts = {
        type:      ds.type || 'slide',
        perPage:   1,
        rewind:    ds.rewind === 'true',
        autoplay:  ds.autoplay === 'true',
        interval:  parseInt(ds.interval || '3000', 10),
        /* ── [MOBILE-SWIPE 2026-06-04] START ─────────────────────────────
           Mirror of the main-slider config in splide-init.js so the swipe
           survives this remount (runs ~600ms after load + on color change).
           Original code was a single line: `drag:      false,`
           To REVERT: delete the 4 lines below and restore `drag: false,`.
           Keep this IN SYNC with splide-init.js (same marker tag). */
        drag:      true,                              // base = mobile (<992px) can swipe
        dragMinThreshold: { mouse: 4, touch: 10 },    // tap still opens zoom
        mediaQuery: 'min',
        breakpoints: { 992: { drag: false } },        // desktop (>=992px): swipe off
        /* ── [MOBILE-SWIPE 2026-06-04] END ─────────────────────────────── */
        arrows:    false,
        pagination: false,
        autoHeight: ds.autoHeight === 'true',
        gap:       '30px'
      };

      var bp = {};
      try { bp = JSON.parse(ds.breakpoints || '{}'); } catch (e) { /* ok */ }

      var thumbOpts = {
        type:         'slide',
        perMove:      parseInt(ds.perMove || '1', 10),
        drag:         ds.drag === 'true',
        arrows:       ds.arrows === 'true',
        pagination:   ds.pagination === 'true',
        rewind:       ds.rewind === 'true',
        gap:          ds.gap || 0,
        isNavigation: true,
        fixedWidth:   ds.fixedWidth  || '',
        fixedHeight:  ds.fixedHeight || '',
        mediaQuery:   'min',
        breakpoints:  bp.responsive || undefined,
        dragMinThreshold: { mouse: 4, touch: 10 }
      };

      var mainSplide  = new Splide(mainEl, mainOpts);
      var thumbSplide = new Splide(thumbEl, thumbOpts);

      mainSplide.sync(thumbSplide);
      mainSplide.mount();
      thumbSplide.mount();

      mainEl.splide  = mainSplide;
      thumbEl.splide = thumbSplide;

      /* Re-attach the inactive handler (pauses video/3D on slide change) */
      mainSplide.on('inactive', function (slide) {
        if (typeof window.pauseElementBasedMedia === 'function') {
          window.pauseElementBasedMedia(slide.slide);
        }
      });
    }

    /* ── 8. Restore all slides to their original lists ─────────── */
    function restoreAll() {
      for (var i = 0; i < origMain.length; i++) {
        mainList.appendChild(origMain[i].el);
      }
      for (var j = 0; j < origThumb.length; j++) {
        thumbList.appendChild(origThumb[j].el);
      }
    }

    /* ── 9. Get the variant's featured image filename ─────────── */
    function getFeaturedFilename(colorValue) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v[colorKey] !== colorValue) continue;
        var src = (v.featured_image && v.featured_image.src)
               || (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src);
        if (!src) continue;
        /* Extract just the filename without query params and size suffix
           e.g. "VDB1221-AB-Hero_uuid.jpg" */
        var filename = src.split('/').pop().split('?')[0];
        /* Remove Shopify's size suffix like _100x, _550x550, etc. */
        filename = filename.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
        return filename.toUpperCase();
      }
      return null;
    }

    /* ── 10. Main filter function ───────────────────────────────── */
    var currentColor = null;

    function filterByColor(colorValue) {
      console.log('[VIF] filterByColor called with:', colorValue);
      if (!colorValue) return;
      if (colorValue === currentColor) { console.log('[VIF] Same color, skipping'); return; }
      currentColor = colorValue;

      captureSlides();

      var myCode = colorCodeMap[colorValue];
      if (!myCode) { showAll(); return; }

      /* Build set of media IDs to hide */
      var hideIds = {};
      for (var i = 0; i < origMain.length; i++) {
        var mid = origMain[i].mediaId;
        if (mid && !shouldShow(mid, myCode)) hideIds[mid] = true;
      }

      /* Destroy current Splide instances */
      destroySplides();

      /* Restore all slides first (in original order) */
      restoreAll();

      /* Move non-matching slides to hidden storage */
      for (var m = 0; m < origMain.length; m++) {
        if (hideIds[origMain[m].mediaId]) storage.appendChild(origMain[m].el);
      }
      for (var t = 0; t < origThumb.length; t++) {
        if (hideIds[origThumb[t].mediaId]) storage.appendChild(origThumb[t].el);
      }

      /* Remount Splide with only visible slides */
      mountSplides();

      /* Jump to the variant's featured image by matching filename in img src */
      var featuredFile = getFeaturedFilename(colorValue);
      var goToIndex = 0;
      if (featuredFile) {
        var visibleSlides = mainList.querySelectorAll(':scope > .splide__slide');
        for (var s = 0; s < visibleSlides.length; s++) {
          var img = visibleSlides[s].querySelector('img');
          if (!img) continue;
          var slideSrc = (img.src || img.currentSrc || '').split('/').pop().split('?')[0];
          slideSrc = slideSrc.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.').toUpperCase();
          if (slideSrc === featuredFile) {
            goToIndex = s;
            break;
          }
        }
      }
      if (mainEl.splide) mainEl.splide.go(goToIndex);
    }

    function showAll() {
      currentColor = null;
      if (!captured) return;
      destroySplides();
      restoreAll();
      mountSplides();
    }

    /* ── 11. Read currently selected color ─────────────────────── */
    function getActiveColor() {
      var hiddenId =
        document.querySelector('input[name="id"][form="main-product-atc-form"]') ||
        document.querySelector('.main-product_submit-from input[name="id"]');

      if (hiddenId) {
        var variant = product.variants.find(function (v) {
          return String(v.id) === hiddenId.value;
        });
        if (variant) return variant[colorKey] || null;
      }

      var checked = document.querySelector(
        'input[type="radio"][name*="Color"]:checked,' +
        'input[type="radio"][name*="Colour"]:checked'
      );
      return checked ? checked.value : null;
    }

    /* ── 12. Event listeners ───────────────────────────────────── */
    ['variant:change', 'product-variant:change', 'variantChange'].forEach(function (name) {
      document.addEventListener(name, function (e) {
        console.log('[VIF] Custom event received:', name);
        var variant = (e.detail && e.detail.variant) || (e.detail && e.detail.selectedVariant);
        if (variant && variant[colorKey]) filterByColor(variant[colorKey]);
      });
    });

    var hiddenInput =
      document.querySelector('input[name="id"][form="main-product-atc-form"]') ||
      document.querySelector('.main-product_submit-from input[name="id"]');

    console.log('[VIF] Hidden input found:', !!hiddenInput);

    if (hiddenInput) {
      /* Watch both attribute and property changes */
      new MutationObserver(function () {
        console.log('[VIF] Hidden input attribute changed');
        var color = getActiveColor();
        if (color) filterByColor(color);
      }).observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

      /* Also poll property changes since .value = x doesn't trigger attribute mutation */
      var lastInputValue = hiddenInput.value;
      var valuePollInterval = setInterval(function() {
        if (hiddenInput.value !== lastInputValue) {
          lastInputValue = hiddenInput.value;
          console.log('[VIF] Hidden input value property changed to:', lastInputValue);
          var color = getActiveColor();
          if (color) filterByColor(color);
        }
      }, 100);
    }

    document.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      console.log('[VIF] Radio change detected:', e.target.name, '=', e.target.value);
      setTimeout(function () {
        var color = getActiveColor();
        console.log('[VIF] After radio change, active color:', color);
        if (color) filterByColor(color);
      }, 50);
    });

    /* ── 13. Initial run (wait for Splide to mount first) ──────── */
    setTimeout(function () {
      var initialColor = getActiveColor();
      console.log('[VIF] Initial color:', initialColor);
      if (initialColor) filterByColor(initialColor);
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
